import { useMemo } from 'react';

import { useDimensions } from '@/hooks';
import { DimensionObject } from '@/hooks/useDimensions/types';

import { OptionsSize, TransactionProps } from '../types';

export interface UseFormHeightArgs {
  transaction: TransactionProps;
  hasOptions: boolean;
}

export interface UseOptionsSizeHook {
  ref: (node: HTMLElement) => void;
  dimensions: DimensionObject | null;
  node: HTMLElement | null;
  size: OptionsSize;
}

export default function useOptionsSize(): UseOptionsSizeHook {
  const [ref, dimensions, node] = useDimensions({ liveMeasure: true, elementType: 'parent' });
  const height = dimensions?.height;
  const size = useMemo(() => {
    if (!height) {
      return 'xs';
    }
    if (height < 120) {
      return 'xs';
    }
    if (height < 165) {
      return 's';
    }
    if (height < 220) {
      return 'm';
    }
    if (height < 250) {
      return 'l';
    }
    return 'xl';
  }, [height]);

  return {
    ref,
    dimensions,
    node,
    size,
  };
}
